import React from 'react';

import { Body, Container, Header, Item, Key, List, Name, Title, Value } from './styles';
import { ProfessorPageQuery_professor } from '../../graphql/queries/__generated__/ProfessorPageQuery';
import { mask } from 'remask';

interface Props {
  professor?: ProfessorPageQuery_professor;
}

const ProfessorInfo: React.FC<Props> = (props) => {
  return (
    <Container>
      <Header>
        <Title>Informações</Title>
      </Header>
      <Body>
        <Name>{props.professor?.dsc_nome_professor}</Name>
        <Item>
          <Key>Titulação:</Key>
          <Value>{props.professor?.dsc_titulacao}</Value>
        </Item>
        <List>
          <Key>Emails:</Key>
          <Value href={`mailto:${props.professor?.dsc_email}`}>
            {props.professor?.dsc_email}
          </Value>
          <Value href={`mailto:${props.professor?.dsc_email2}`}>
            {props.professor?.dsc_email2}
          </Value>
          <Value href={`mailto:${props.professor?.dsc_email3}`}>
            {props.professor?.dsc_email3}
          </Value>
        </List>
        <List>
          <Key>Telefones:</Key>
          {/* _bank */}
          <Value href={`http://api.whatsapp.com/send?phone=55${props.professor?.dsc_num_telefone}`} target='_blank'>
            {mask(props.professor?.dsc_num_telefone || '', ['(99) 9999-9999', '(99) 99999-9999'])}
          </Value>
          <Value href={`http://api.whatsapp.com/send?phone=55${props.professor?.dsc_num_telefone}`} target='_blank'>
            {mask(props.professor?.dsc_num_telefone2 || '', ['(99) 9999-9999', '(99) 99999-9999'])}
          </Value>
        </List>
      </Body>
    </Container>
  );
};

export { ProfessorInfo };
